import { AxiosError } from "axios";
import { showNotification } from "../../common/actionCreators/dispatchNotification";
import apiClient from "../../common/api/apiClient";
import { ApiError } from "../../common/api/apiResponse";
import {AppNotificationDto} from './notifications.dto'

const notificationsUrl = '/notifications/';

export const getNotificationApi = async (request: string) => {
    return await apiClient.get(notificationsUrl + request)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving notification.', 'error');
        }
        throw err;
    });
};

export const createNotificationApi = async (request: AppNotificationDto) => {
    return await apiClient.post(notificationsUrl, request)
      .then((res) => {
        showNotification("Notification sent", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while sending notification.', 'error');
        }
        throw err;
      });
};